import { defineGlobal } from '@aliyun-sls/web-base';
import CryptoJS from 'crypto-js';

function encrypt(target) {
  return CryptoJS.MD5(target).toString().toUpperCase();
}

function getSign(method, uri, access_key_id, access_key_secret, params, headers, sct, datestr) {
  var _a;
  let message = "";
  headers.set("x-log-apiversion", "0.6.0");
  headers.set("x-log-signaturemethod", "hmac-sha1");
  message += method + "\n" + sct + "\n" + ((_a = headers.get("Content-Type")) != null ? _a : "") + "\n" + datestr + "\n";
  const sort_by_key = (a, b) => a[0].localeCompare(b[0]);
  const filter_by_prefix = (e) => e[0].startsWith("x-log-") || e[0].startsWith("x-acs-");
  try {
    const header_str = [...headers.entries()].filter(filter_by_prefix).sort(sort_by_key).map((e) => e[0] + ":" + e[1] + "\n").join("");
    message += header_str;
  } catch (error) {
  }
  message += uri;
  if (params.size > 0) {
    message += "?";
  }
  try {
    message += [...params.entries()].sort(sort_by_key).map((e) => e[0] + "=" + e[1]).join("&");
  } catch (error) {
  }
  const signature = CryptoJS.HmacSHA1(message, access_key_secret).toString(CryptoJS.enc.Base64);
  const auth = "LOG " + access_key_id + ":" + signature;
  headers.set("Authorization", auth);
  headers.set("x-log-date", datestr);
  return auth;
}

var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function setSTSToken(options) {
  return __async$1(this, null, function* () {
    const now = /* @__PURE__ */ new Date();
    if (!options.refreshSTSTokenInterval) {
      options.refreshSTSTokenInterval = 3e5;
    }
    if (!options.stsTokenFreshTime || +now - options.stsTokenFreshTime >= options.refreshSTSTokenInterval) {
      options.stsTokenFreshTime = now;
      try {
        yield options.refreshSTSToken();
      } catch (error) {
        if (typeof console.error === "function") {
          console.error("Some error occured during excuting refreshSTSToken, see:\n" + error);
        }
      }
    }
    return null;
  });
}

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function createStsPlugin(opt) {
  return {
    transString: function(obj) {
      let newObj = {};
      let timeValue = 0;
      let hastime = false;
      for (let i in obj) {
        if ((i === "time" || i === "__time__") && typeof obj[i] == "number") {
          timeValue = obj[i];
          hastime = true;
          continue;
        }
        if (typeof obj[i] === "object") {
          newObj[i] = JSON.stringify(obj[i]);
        } else {
          newObj[i] = String(obj[i]);
        }
      }
      newObj["__time__"] = hastime ? timeValue : Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3);
      return newObj;
    },
    process: function(url, payload, assginedDate) {
      return __async(this, null, function* () {
        yield setSTSToken(opt);
        let path = url.slice(url.indexOf("/logstores"));
        let rawsize = payload.length;
        let sct = encrypt(payload);
        let datestr = "";
        let localCurTimestamp = (/* @__PURE__ */ new Date()).getTime() / 1e3;
        opt.latestTime = localCurTimestamp;
        let timeGap = opt.latestInvalidTime ? localCurTimestamp - opt.latestInvalidTime : 0;
        if (assginedDate) {
          opt.latestInvalidTime = opt.latestTime;
          opt.latestValidTime = assginedDate;
        }
        if (assginedDate) {
          datestr = new Date(assginedDate * 1e3).toUTCString();
        } else {
          if (opt.latestValidTime) {
            const curValidTime = opt.latestValidTime + timeGap;
            datestr = new Date(curValidTime * 1e3).toUTCString();
          } else {
            datestr = new Date(localCurTimestamp * 1e3).toUTCString();
          }
        }
        let param = /* @__PURE__ */ new Map();
        let headers = /* @__PURE__ */ new Map([
          ["Content-Type", "application/json"],
          ["Content-MD5", sct],
          ["x-log-bodyrawsize", rawsize.toString()]
        ]);
        if (opt.securityToken) {
          headers.set("x-acs-security-token", opt.securityToken);
        }
        getSign("POST", path, opt.accessKeyId, opt.accessKeySecret, param, headers, sct, datestr);
        let header = Object.fromEntries(headers);
        return {
          data: payload,
          header
        };
      });
    }
  };
}
if (typeof window !== "undefined") {
  defineGlobal(window, "stsPlugin", createStsPlugin);
}

export { createStsPlugin as default };
//# sourceMappingURL=web-sts-plugin.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aliyun-sls/web-sts-plugin/dist/web-sts-plugin.es.js
// module id = PHUd
// module chunks = 129